import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("relative overflow-hidden rounded-md bg-muted after:absolute after:inset-0 after:-translate-x-full after:animate-sheen after:bg-gradient-to-r after:from-transparent after:via-[var(--glass-hilite)] after:to-transparent", className)}
      {...props}
    />
  )
}

export { Skeleton }
